import React, { useRef } from 'react';
import { AlertCircle } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
export function PainSection() {
  const pains = ['You just arrived (or you’re arriving soon) and everything feels urgent.', 'You’re scared of getting trapped in a bad housing situation.', 'You don’t know what’s “normal” pricing, terms, or process.', 'You keep thinking: “I don’t want to depend on people for every little thing.”', 'You’re making decisions while stressed—and you know that’s dangerous.'];
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-20 px-4 sm:px-6 bg-[#EDE8E3]" data-id="element-145">
      <div className="max-w-3xl mx-auto" data-id="element-146">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="bg-[#FAF8F6] p-8 md:p-12 rounded-2xl shadow-sm border border-neutral-200" data-id="element-147">
          <h2 className="text-3xl font-bold text-neutral-900 mb-8 font-serif" data-id="element-148">
            The moment this is for
          </h2>
          <p className="text-lg text-neutral-600 mb-8" data-id="element-149">
            If any of these are true, you’re the person this kit was built for:
          </p>

          <ul className="space-y-4" data-id="element-150">
            {pains.map((pain, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1 + 0.3
          }} className="flex items-start gap-4" data-id="element-151">
                <AlertCircle className="h-6 w-6 text-red-700 flex-shrink-0 mt-0.5" data-id="element-152" />
                <span className="text-lg text-neutral-800" data-id="element-153">{pain}</span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="mt-10 pt-8 border-t border-neutral-100" data-id="element-154">
            <p className="text-xl font-serif italic text-neutral-700" data-id="element-155">
              "This isn’t about being dramatic. It’s about being realistic. The
              first 14 days are when you’re most vulnerable."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}